module.exports = __webpack_public_path__ + "img/chair_hot_on.4fc249a8.png";